var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"use-cms-folder":"/Content/Layouts/Clean"},scopedSlots:_vm._u([{key:"container",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }